import styled from '@emotion/styled';
import breakpoints from '../../theme/material/breakpoints';

export const Content = styled('div')({
  [breakpoints.up(769)]: {
    display: 'flex',
    flexFlow: 'row',
    minWidth: 0,
    flex: 1,
  },
});

export const PrimaryContent = styled('div')({
  [breakpoints.up(480)]: {
    minHeight: 175,
  },
  [breakpoints.up(769)]: {
    minWidth: 0,
    flex: 1,
  },
});
